import { getTableIBM } from "../data.checker";
import { IBM_TABLES } from "./ibm/tables";

export let buyers: {[key:string]:string} = getTableIBM(IBM_TABLES.CERoo7);

export function updateBuyers(data:{[key:string]:string}){
    buyers=data;
}